import React from 'react';
import './FullContact.css';
import socialIdeas from '../../img/socialIdeas.png'

export default function FullContact() {
    return (
        <section id="full-contact">
            <div className="container">
                <div>
                    <h2>Let's Connect</h2>
                </div>

                <figure>
                    <img className="contact-image" src={ socialIdeas } alt="Social Ideas Illustration" />
                </figure>

                
                <div className="contact-info">
                    <h3>Call or Email</h3>
                    <p>951-667-5351</p>
                    <a className="email" href="mailto:abowler2@gmail.com">abowler2 [@] gmail.com</a>
                </div>

                <div className="social">
                    <h3>Visit My Blog</h3>
                    <p className="social-icons"><a href="https://www.findingmyinnercoder.com"><i className="fas fa-comment-dots"></i></a></p>
                </div>

                <div className="social">
                    <h3>Find Me On GitHub</h3>
                    <p className="social-icons"><a href="https://github.com/abowler2"><i className="fab fa-github"></i></a></p>
                </div>

                <div className="social">
                    <h3>Connect on Social</h3>
                    <div className="social-links">
                        <p className="social-icons"><a href="https://www.linkedin.com/in/abowler2/"><i className="fab fa-linkedin-in"></i></a></p>
                        <p className="social-icons"><a href="https://twitter.com/A_Bowler2"><i className="fab fa-twitter"></i></a></p>
                    </div>
                </div>
            </div>
        </section>
    );
}